import { datadogRum } from '@datadog/browser-rum';
import { ErrorInfo } from 'react';

export const dataDogErrorHandler = (error: unknown, info: ErrorInfo) => {
  datadogRum.addError(error, info);
};
